import { T as r } from "./utils.BA8Gszn5.js";
const m = (o, n) => r(o, n);
export {
  m as n
};
//# sourceMappingURL=useSanitizeHtml.Cb2JX5jy.js.map
